import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { apiService } from '../../services/api.service';
import { globalData } from '../../services/globalData.service';

@Component({
  selector: 'app-create-new-account',
  templateUrl: './create-new-account.component.html',
  styleUrls: ['./create-new-account.component.scss']
})
export class CreateNewAccountComponent implements OnInit {


  @Output() childButtonEvent = new EventEmitter();

  clickHandler() {
    this.childButtonEvent.emit(1);
  }

  myForm: FormGroup;

  @Output() countryCodeSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickHandlerSuccessful: EventEmitter<number> = new EventEmitter<number>();

  isOpen: boolean = false;
  selectedCountryCode: string = ''; // Default selected country code
  captchaValue: string;
  errorMessage: string = '';
  errorMessageCaptch: string;
  errorMessagePassword: string;
  isCountrySelected: boolean = false;
  mobileNoMaxLength: number = 10;
  mobileNo_Or_Email: string = '';
  registerSuccessful: boolean = false;
  showRegisterSuccessMessage: boolean = false;
  isRegisterForm: boolean = true;
  isOTPSend = false;
  enterOTP = false;
  registerOTP: string = '';
  otpSentOnText: string = '';
  otpSentText: string = '';
  countryCodes: any[] = [];
  @ViewChild('inputA') inputA: ElementRef;
  @ViewChild('inputB') inputB: ElementRef;
  @ViewChild('inputC') inputC: ElementRef;
  @ViewChild('inputD') inputD: ElementRef;
  @ViewChild('inputE') inputE: ElementRef;
  @ViewChild('inputF') inputF: ElementRef;

  pwdMinLength: number = 0;
  pwdUpperCaseLength: number = 0;
  pwdLowerCaseLength: number = 0;
  pwdNumericCharLength: number = 0;
  pwdPsecialCharLength: number = 0;
  pwdAlphaNumericharLength: number = 0;

  constructor(private _apiService: apiService, public global: globalData) { }


  ngOnInit() {
    this.isOpen = false;

    this.myForm = new FormGroup({
      mobile: new FormControl('', Validators.required),
      email: new FormControl('', Validators.email),
      password: new FormControl('', Validators.required),
      captcha: new FormControl('', Validators.required),
      searchText: new FormControl('')
    });

    this.generateCaptcha();
    this.countryCodes = [];

    this.getPasswordValidationData();
    this.GetCountryList();
  }

  search() {
    this.errorMessage = "";
    this.GetCountryList();
  }

  GetCountryList() {
    var searchText = this.myForm.value.searchText;

    this.global.GetCountryList(searchText).then((countryCodes: any[]) => {
      this.countryCodes = countryCodes;

      if (!this.isCountrySelected && this.countryCodes.length > 0) {
        var country = this.countryCodes.find(item => item.iso_code === this.global.customerCountryCode);
        if (country) {
          this.selectedCountryCode = country.isd_code;
          this.mobileNoMaxLength = country.mobNo_length;
        }
        else {
          this.selectedCountryCode = this.countryCodes[0].isd_code;
          this.mobileNoMaxLength = this.countryCodes[0].mobNo_length;
        }
      }
    });
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // Prevent the click event from reaching parent elements
    this.isOpen = !this.isOpen;
  }

  emitClickHandlerSuccessful() {
    this.clickHandlerSuccessful.emit(5);
  }

  generateCaptcha() {
    // Logic to generate a random captcha value
    // For simplicity, let's use a 4-digit number as the captcha
    this.captchaValue = Math.floor(1000 + Math.random() * 9000).toString();
  }

  regenerateCaptcha() {
    this.myForm.get('captcha')?.setValue('');
    this.generateCaptcha();
  }

  onInputChange(inputElement: any): void {
    const inputValue = inputElement.value;
    const maxLength = inputElement.maxLength;

    if (inputValue.length === maxLength) {
      // Focus on the next input element
      const nextInput = inputElement.nextElementSibling;
      if (nextInput instanceof HTMLInputElement) {
        nextInput.focus();
      }
    }
  }

  countryCodeSelect(code: any, event: Event) {
    this.errorMessage = "";
    this.isOpen = false; // Close the dropdown when an option is selected
    this.mobileNoMaxLength = code.mobNo_length;
    this.myForm.get('searchText')?.setValue('');
    this.isCountrySelected = true;
    this.GetCountryList();
    this.selectedCountryCode = code.isd_code;
    this.mobileNoMaxLength = code.mobNo_length;
    this.countryCodeSelected.emit(this.selectedCountryCode); // Emit the selected country code if needed
  }

  isPasswordVisible: boolean = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  isMobileNumberTabActive: boolean = true;
  isEmailTabActive: boolean = false;

  showMobileNumberTab() {
    this.isMobileNumberTabActive = true;
    this.isEmailTabActive = false;

    this.myForm.get('mobile')?.setValidators([Validators.required])
    this.myForm.get('mobile')?.updateValueAndValidity();

    this.myForm.get('email')?.clearValidators();
    this.myForm.get('email')?.updateValueAndValidity();
  }

  showEmailTab() {
    this.isMobileNumberTabActive = false;
    this.isEmailTabActive = true;

    this.myForm.get('email')?.setValidators([Validators.required])
    this.myForm.get('email')?.updateValueAndValidity();

    this.myForm.get('mobile')?.clearValidators();
    this.myForm.get('mobile')?.updateValueAndValidity();
  }

  customerRegister(form: FormGroup) {
    this.errorMessage = "";

    const headers = { "Content-Type": "application/json" };
    var value = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    this.mobileNo_Or_Email = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    if (form.valid && form.value.captcha === this.captchaValue && value) {
      const bodyParam = {
        "language_code": localStorage.getItem('languageCode'),
        "signup_with": this.isMobileNumberTabActive ? 'mobile' : 'email',
        "isd_code": this.selectedCountryCode,
        "customer_mobile_or_email": this.isMobileNumberTabActive ? form.value.mobile : form.value.email,
        "password": form.value.password
      };

      this._apiService.customerSignup(bodyParam, headers).subscribe(response => {
        if (response.success == true) {
          this.registerSuccessful = true;
          console.log('Login successful');
          let responseObj = response.data;
          this.showRegisterSuccessMessage = true;
          this.emitClickHandlerSuccessful();
        }
        else {
          this.errorMessage = response.message;
        }
      });
    }
    else {
      if (!value) {
        this.errorMessage = this.isMobileNumberTabActive ? 'Please enter Mobile No.' : 'Please enter Email.';
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
      if (!form.value.password) {
        this.errorMessagePassword = 'Please Enter Password';
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
      const controls = form.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          this.errorMessageCaptch = name.toUpperCase() + ' is Invalid';
          form.get('captcha')?.setValue('');
          this.regenerateCaptcha();
          return;
        }
      }
      if (form.value.captcha != this.captchaValue) {
        this.errorMessageCaptch = "Captch is not matching";
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
    }
  }

  verifyOTP() {
    const headers = { "Content-Type": "application/json" };

    const OTP = this.inputA.nativeElement.value + this.inputB.nativeElement.value + this.inputC.nativeElement.value + this.inputD.nativeElement.value + this.inputE.nativeElement.value + this.inputF.nativeElement.value;
    const bodyParam = {
      "language_code": localStorage.getItem('languageCode'),
      "type": this.isMobileNumberTabActive ? 'mobile' : 'email',
      "isd_code": this.selectedCountryCode,
      "mobile_or_email": this.mobileNo_Or_Email,
      "otp": OTP
    };

    this._apiService.verifyOTP(bodyParam, headers).subscribe(resp => {
      if (resp.success == true) {
        this.closeModal.emit();
      }
      else {
        this.closeModal.emit();
      }
    });
  }

  passwordPatternValidator(minimumLength: number, specialCharLength: number, alphanumericLength: number, upperCaseLength: number, lowerCaseLength: number, numericLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;

      if (!value) {
        // If the value is empty, don't perform validation
        return null;
      }

      // Check minimum length
      if (value.length < minimumLength) {
        return { 'minLength': true };
      }

      // Check special characters
      const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/g;
      if ((value.match(specialCharRegex) || []).length < specialCharLength) {
        return { 'specialChars': true };
      }

      // Check alphanumeric characters
      const alphanumericRegex = /^[a-zA-Z0-9]+$/;
      if ((value.match(alphanumericRegex) || []).length < alphanumericLength) {
        return { 'alphanumericChars': true };
      }

      // Check uppercase characters
      const upperCaseRegex = /[A-Z]/g;
      if ((value.match(upperCaseRegex) || []).length < upperCaseLength) {
        return { 'upperCaseChars': true };
      }

      // Check lowercase characters
      const lowerCaseRegex = /[a-z]/g;
      if ((value.match(lowerCaseRegex) || []).length < lowerCaseLength) {
        return { 'lowerCaseChars': true };
      }

      // Check numeric characters
      const numericRegex = /[0-9]/g;
      if ((value.match(numericRegex) || []).length < numericLength) {
        return { 'numericChars': true };
      }

      // If all conditions are met, return null (no validation error)
      return null;
    };
  }

  getPasswordValidationData() {
    this._apiService.getGeneral()
      .subscribe(
        data => {
          let generalData = data.data;

          if (generalData?.PasswordValidation) {
            this.pwdMinLength = generalData?.PasswordValidation[0].minimum_length;
            this.pwdUpperCaseLength = generalData?.PasswordValidation[0].upper_case_characters;
            this.pwdLowerCaseLength = generalData?.PasswordValidation[0].lower_case_characters;
            this.pwdNumericCharLength = generalData?.PasswordValidation[0].numeric_characters;
            this.pwdPsecialCharLength = generalData?.PasswordValidation[0].special_characters;
            this.pwdAlphaNumericharLength = generalData?.PasswordValidation[0].alphanumeric_characters;

            this.myForm.get('password')?.setValidators([
              Validators.required,
              this.passwordPatternValidator(this.pwdMinLength, this.pwdPsecialCharLength, this.pwdAlphaNumericharLength, this.pwdUpperCaseLength, this.pwdLowerCaseLength, this.pwdNumericCharLength)
            ]);

            this.myForm.get('password')?.updateValueAndValidity();
          }
        }
      )
  }

}
